// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"28de89fa","166":"28de89fa","194":"28de89fa","255":"28de89fa","324":"28de89fa","345":"28de89fa","380":"28de89fa","481":"28de89fa","576":"28de89fa","663":"28de89fa"}[chunkId] + ".chunk.css";
};